import PropTypes from "prop-types";
import React, { useMemo } from "react";
import classNames from "classnames";
import { SVGIcon2 } from "./common/SVGIconV2";

const CTAButton = props => {
  const {
    onClick,
    type,
    title,
    titleDataTestId,
    aCclassName,
    icon,
    btnContext,
    isLoading,
    trackingInfo,
    children
  } = props;

  const handleCTA = e => {
    console.log(`${type} button clicked`);
    onClick(e);
  };

  const trackingInfoLocal = trackingInfo
    ? Object.assign({}, trackingInfo, { dataLabel: type })
    : Object.assign({}, trackingInfo, {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: type
      });
  const contextClassId = btnContext + aCclassName;
  const linkProps = {
    "data-testid": contextClassId,
    className: classNames(
      "button-default",
      aCclassName,
      contextClassId,
      isLoading ? "dots-floating" : ""
    ),
    id: contextClassId,
    onClick: handleCTA
  };

  const titleComponent = useMemo(
    () =>
      titleDataTestId ? (
        <span data-testid={titleDataTestId}>{title}</span>
      ) : (
        title
      ),
    [titleDataTestId, title]
  );

  return (
    <a
      {...linkProps}
      data-category={trackingInfoLocal.dataCategory}
      data-action={trackingInfoLocal.dataAction}
      data-label={trackingInfoLocal.dataLabel}
      data-value=""
    >
      {!isLoading && icon && <SVGIcon2 iconName={icon} />}
      {!isLoading && titleComponent}
      {!isLoading && children}
      {isLoading && (
        <>
          <hr></hr>
          <hr></hr>
          <hr></hr>
        </>
      )}
    </a>
  );
};

CTAButton.propTypes = {
  aCclassName: PropTypes.string,
  btnContext: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  titleDataTestId: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  trackingInfo: PropTypes.object,
  children: PropTypes.node
};

export default React.memo(CTAButton);
